<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12">
    <app-datepicker-form-field
      formControlName="createdAt"
      [label]="'case.fields.createdAt.label' | translate"
      [viewMode]="viewMode"
  ></app-datepicker-form-field>
  </div>
  <div class="col-12">
    <app-status-select-field
      formControlName="caseStatus"
      [label]="'case.fields.caseStatus.label' | translate"
      [helpText]="'case.fields.caseStatus.help'"
      [items]="statusItems"
      [bindValue]="'value'"
      [customClass]="'case-right-section'"
      [isDisabledField]="true"
      [itemClass]="form.get('caseStatus')?.value"
    ></app-status-select-field>
  </div>
  <div class="col-12">
    <app-severity-select-field
      formControlName="severity"
      [label]="'case.fields.severityTicketInfo.label' | translate"
      [helpText]="'case.fields.severityTicketInfo.help'"
      [placeholder]="'placeholders.please_select'"
      [items]="severityItems"
      [optionItem]="'name'"
      [bindValue]="'value'"
      [customClass]="'case-right-section'"
      (onSelectEvent)="changeSeverity($event)"
    ></app-severity-select-field>
  </div>
  <div class="col-12">
    <app-input-form-field
      formControlName="productSuite"
      [label]="'case.fields.productSuite.label' | translate"
      [helpText]="'case.fields.productSuite.help'"
      [viewMode]="viewMode"
      [translatable]="false"
    ></app-input-form-field>
  </div>
  <div class="col-12">
  <app-input-form-field
      formControlName="productCompany"
      [label]="'case.fields.productCompany.label' | translate"
      [helpText]="'case.fields.productCompany.help'"
      [viewMode]="viewMode"
      [translatable]="false"
    ></app-input-form-field>
  </div>
  <div class="col-12">
    <app-datepicker-form-field
      formControlName="verifyDate"
      [label]="'case.fields.verifyDate.label' | translate"
      [helpText]="'case.fields.verifyDate.help'"
      [viewMode]="viewMode"
    ></app-datepicker-form-field>
  </div>
  <div class="col-12">
    <app-datepicker-form-field
      formControlName="caseClosedDate"
      [label]="'case.fields.caseClosedDate.label' | translate"
      [helpText]="'case.fields.caseClosedDate.help'"
      [viewMode]="viewMode"
    ></app-datepicker-form-field>
  </div>
  <div class="col-12">
    <app-datepicker-form-field
      formControlName="initialResponseDate"
      [label]="'case.fields.initialResponseDate.label' | translate"
      [helpText]="'case.fields.initialResponseDate.help'"
      [viewMode]="viewMode"
    ></app-datepicker-form-field>
  </div>
</div>
